module.exports = __webpack_public_path__ + "static/media/gift.2a10d1f1.svg";